const NoPage: React.FC = () => {
  return (
    <>
      <h1>404</h1>
      <p>Page not found</p>
    </>
  );
};
export default NoPage;
